import { on } from "@ngrx/store";
import { DeveloperState } from "../developer.state";
import { AttioRecordMigrationActions } from "./attio-record-migration.actions";
import { AttioRecordMigrationKind, AttioRecordMigrationSlot } from "./attio-record-migration.state";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update one migration's slot within PagesStore
// **************************************************************************

function withSlot(
    state: PagesStore,
    kind: AttioRecordMigrationKind,
    updater: (slot: AttioRecordMigrationSlot) => Partial<AttioRecordMigrationSlot>,
    error?: DeveloperState["error"],
): PagesStore {
    const developer = state.developer;
    const migrations = developer.attioRecordMigration;
    return {
        ...state,
        developer: {
            ...developer,
            attioRecordMigration: { ...migrations, [kind]: { ...migrations[kind], ...updater(migrations[kind]) } },
            error: error === undefined ? developer.error : error,
        },
    };
}

// **************************************************************************
// ATTIO RECORD MIGRATION REDUCER (array format for PagesStore)
// **************************************************************************

// *** PREVIEW ***
const loadPreview = on(AttioRecordMigrationActions.loadPreview, (state: PagesStore, { kind }) =>
    withSlot(state, kind, m => ({ loading: { ...m.loading, loadingPreview: true } }), null));

const loadPreviewSuccess = on(AttioRecordMigrationActions.loadPreviewSuccess, (state: PagesStore, { kind, preview }) =>
    withSlot(state, kind, m => ({ preview, loading: { ...m.loading, loadingPreview: false } }), null));

const loadPreviewFailure = on(AttioRecordMigrationActions.loadPreviewFailure, (state: PagesStore, { kind, error }) =>
    withSlot(state, kind, m => ({ loading: { ...m.loading, loadingPreview: false } }), error));

// *** RUN ***
const start = on(AttioRecordMigrationActions.start, (state: PagesStore, { kind }) =>
    withSlot(state, kind, m => ({ loading: { ...m.loading, starting: true } }), null));

const startSuccess = on(AttioRecordMigrationActions.startSuccess, (state: PagesStore, { kind, status }) =>
    withSlot(state, kind, m => ({ status, loading: { ...m.loading, starting: false } }), null));

const startFailure = on(AttioRecordMigrationActions.startFailure, (state: PagesStore, { kind, error }) =>
    withSlot(state, kind, m => ({ loading: { ...m.loading, starting: false } }), error));

// *** STATUS ***
const loadStatusSuccess = on(AttioRecordMigrationActions.loadStatusSuccess, (state: PagesStore, { kind, status }) =>
    withSlot(state, kind, () => ({ status })));

const loadStatusFailure = on(AttioRecordMigrationActions.loadStatusFailure, (state: PagesStore, { kind, error }) =>
    withSlot(state, kind, () => ({}), error));

export const attioRecordMigrationReducer = [
    loadPreview,
    loadPreviewSuccess,
    loadPreviewFailure,
    start,
    startSuccess,
    startFailure,
    loadStatusSuccess,
    loadStatusFailure,
];
